import ChordsPage from './Pages/ChordsPage';
import ArtistPage from './Pages/ArtistPage';
import ArtistsPage from './Pages/ArtistsPage';
import Explore from './Pages/Explore';
import ExtensionPage from './Pages/ExtensionPage';
import ImportPage from './Pages/ImportPage';
import KanbanPage from './Pages/KanbanPage';
import SongPage from './Pages/SongPage';
import UrlRedirectPage from './Pages/UrlRedirectPage';
import UserSongsPage from './Pages/UserSongsPage';
import EditSongPage from './Pages/EditSongPage';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Layout from './Layout';
import theme from './theme';
import React from 'react';
import { UserProvider } from './utils/useUser';
import { UrlImportsProvider } from './utils/useUrlImports';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <BrowserRouter>
          <UrlImportsProvider>
          <CssBaseline />
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/Explore" replace />} />
              <Route path="/Explore" element={<Explore />} />
              <Route path="/Chords" element={<ChordsPage />} />
              <Route path="/Artists" element={<ArtistsPage />} />
              <Route path="/Artist" element={<ArtistPage />} />
              <Route path="/Artist/:artistName" element={<ArtistPage />} />
              <Route path="/Song" element={<SongPage />} />
              <Route path="/MySongs" element={<UserSongsPage />} />
              <Route path="/my-songs" element={<UserSongsPage />} />
              <Route path="/UserSongs" element={<Navigate to="/MySongs" replace />} />
              <Route path="/EditSong" element={<EditSongPage />} />
              <Route path="/EditSong/:id" element={<EditSongPage />} />
              <Route path="/edit-song" element={<EditSongPage />} />
              <Route path="/Kanban" element={<KanbanPage />} />
              <Route path="/MyLists" element={<KanbanPage />} />
              <Route path="/Playlists" element={<KanbanPage />} />
              <Route path="/Lists" element={<KanbanPage />} />
              <Route path="/Import" element={<ImportPage />} />
              <Route path="/import" element={<ImportPage />} />
              <Route path="/Add" element={<ImportPage />} />
              <Route path="/import/*" element={<UrlRedirectPage />} />
              <Route path="/Import/*" element={<UrlRedirectPage />} />
              <Route path="/Extension" element={<ExtensionPage />} />
              <Route path="/extension" element={<ExtensionPage />} />
              <Route path="/url/*" element={<UrlRedirectPage />} />
              <Route path="/url" element={<UrlRedirectPage />} />
              <Route path="*" element={<Navigate to="/Explore" replace />} />
            </Routes>
          </Layout>
          </UrlImportsProvider>
        </BrowserRouter>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;

